import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import {
  getUser,
  goToSignup,
  fetchEmailHandler,
  setUserInformations,
  setOnboardingTemplates,
} from './state'

import { getConfig } from '../../../config'
import { validateEmail } from '../../../utils/index'
import { useQueryParams } from '../../../hooks/useQueryParams'
import {
  SUPER_ENABLED_KEY,
  FROM_MOBILE_APP_KEY,
  setItemSafe,
} from '../../../helpers/localStorage'
import { setSuperTrialToken } from '../../../helpers/superTrial'

// Get channels or notes params in URL to scaffold it on workspace creation.

type CreateQueryParams = {
  ask?: string
  mobile?: string
  email?: string
  channelToken?: string
  gspk?: string // GrowSumoPartnerKey, use by PartnerStack referral system to identify partner
}

export function Initialize({ superEnabled }: { superEnabled: boolean }) {
  const dispatch = useDispatch()
  const { emailHandler } = useSelector(getUser)
  const { apiUrl } = useSelector(getConfig)
  useEffect(() => {
    setSuperTrialToken()
  })

  const {
    channelToken,
    email,
    mobile: fromMobileApp,
  } = useQueryParams<CreateQueryParams>()
  const isValidEmail = email ? validateEmail(email) : false

  useEffect(() => {
    if (channelToken) {
      dispatch(setOnboardingTemplates({ templateChannelToken: channelToken }))
    }
  }, [dispatch, channelToken])

  useEffect(() => {
    setItemSafe(FROM_MOBILE_APP_KEY, fromMobileApp ?? 'false')
  }, [fromMobileApp])

  useEffect(() => {
    if (isValidEmail) {
      dispatch(setUserInformations({ email }, false))
      dispatch(fetchEmailHandler(email))
    }
    setItemSafe(SUPER_ENABLED_KEY, superEnabled ? 'true' : 'false')
  }, [dispatch, email, isValidEmail, superEnabled])

  useEffect(() => {
    // Go to Start step
    const goToNext = () => dispatch(goToSignup())

    // If it's not a valid email
    if (!isValidEmail) {
      goToNext()
    } else {
      // If uses gmail or google workspace email
      if (emailHandler === 'google') {
        window.location.href = `${apiUrl}/auth/google/signup?loginHint=${email}`
      } else if (emailHandler === 'unknown') {
        goToNext()
      }
    }
  }, [apiUrl, dispatch, email, emailHandler, isValidEmail])

  return <></>
}
